export default __webpack_public_path__ + "static/media/img-0310-brazil-premium-face.20a31504.png";